import { Box } from "@mui/material";
import { Navigate, useParams } from "react-router-dom";

import PaymentLinkNavBar from "../PaymentLinkNavBar";

import PaymentSummary from "./PaymentSummary/PaymentSummary";

import APP_ROUTES from "../../../routers/routeConstants";
import SucceedFigure from "../../../assets/images/payment-link/succeed.png";

const PaymentSucceed = () => {
  // const { transactionId } = useParams();

  // if (!transactionId) return <Navigate to={APP_ROUTES.NOT_FOUND} />;

  return (
    <Box>
      <PaymentLinkNavBar />
      <Box sx={{ display: "flex", height: "calc(100vh - 80.93px)" }}>
        {/* <PaymentSummary transactionId={transactionId} /> */}
        <PaymentSummary />
        <Box
          sx={{
            width: "50%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img src={SucceedFigure} width="449.149px" height="281.256px" />
        </Box>
      </Box>
    </Box>
  );
};

export default PaymentSucceed;
